import { IEvent, IHost } from "@Interfaces";
import { getPlanData } from "@Modules/eventPage/utils/plan";
import { IAboutPlan } from "@Modules/eventPage/components/AboutPlan/IAboutPlan";
import { getHideAboutPlan } from "./getHideAboutPlan";

export const getPlanHeaderTitle = ({
    planData,
}: {
    planData: IHost.IPlanDetail;
}) => `${planData?.metadata?.about_header || "Plan"}`;

export const getAboutPlanProps = ({
    planId,
    eventData,
    host,
}: {
    planId?: string;
    eventData: IEvent.IEventData;
    host: IHost.IStore;
}): IAboutPlan.IProps => {
    const planData = getPlanData({
        host,
        planId,
    });

    const descMaxLength = 500;
    const planDescription = planData?.description || "";
    const eventDescription = eventData?.description || "";
    const hideComponent = getHideAboutPlan({ planId });

    return {
        hideComponent,
        minifyEventDescription:
            eventData?.metadata?.event_desc_minify_length ?? true, // true if not defined
        descMaxLength,
        aboutEventHeader: `About the ${getPlanHeaderTitle({ planData })}`,
        planDescription: `${planDescription}${
            planDescription && eventDescription ? "<hr/>" : ""
        }${eventDescription}`,
    };
};
